const getApiOrigin = (): string => {
  const raw = process.env.REACT_APP_API_URL || "";
  // Allow either https://host or https://host/api
  return raw.replace(/\/api\/?$/, "").replace(/\/$/, "");
};

export const buildMediaUrl = (url?: string | null): string => {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  const origin = getApiOrigin();
  if (!origin) return url;
  return `${origin}${url.startsWith("/") ? "" : "/"}${url}`;
};

// Structurally typed so it accepts any playlist-shaped record (list rows,
// details, article payloads) without coupling this util to a domain type.
type PlaylistCoverSource = {
  overwriteShowRadioImage?: { url?: string | null } | null;
  show?: { radioImage?: { url?: string | null } | null } | null;
};

// A playlist's cover is its per-playlist override, falling back to the show's
// radio image. Kept in one place so the list, details and preview views can't
// drift apart on which image they show.
export const getPlaylistCoverUrl = (
  playlist?: PlaylistCoverSource | null
): string | undefined =>
  playlist?.overwriteShowRadioImage?.url ||
  playlist?.show?.radioImage?.url ||
  undefined;
